import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaSearch, FaShoppingCart, FaBell, FaUser } from 'react-icons/fa';
import './MobileNavigation.css';

const MobileNavigationBuyer = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  // Handle navigation with same-page prevention
  const handleNavigation = (path, event) => {
    // Prevent navigation if already on the same page
    if (location.pathname === path) {
      event?.preventDefault();
      event?.stopPropagation();
      console.log('Already on page, preventing navigation:', path);
      return false;
    }
    
    // Allow normal navigation for different pages
    console.log('Navigating to:', path);
    return true;
  };
  
  // Add/remove mobile nav visibility class on mount/unmount
  useEffect(() => {
    document.body.classList.add('mobile-nav-visible');
    return () => {
      document.body.classList.remove('mobile-nav-visible');
    };
  }, []);

  return (
    <nav className={`mobile-nav buyer-nav ${location.pathname === '/login' || location.pathname === '/register' ? 'auth-page' : ''}`}>
      <Link 
        to="/" 
        className={`nav-item ${isActive('/') ? 'active disabled' : ''}`}
        onClick={(e) => handleNavigation('/', e)}
      >
        <FaHome className="nav-icon" />
        <span className="nav-label">Home</span>
      </Link>
      <Link 
        to="/products" 
        className={`nav-item ${isActive('/products') ? 'active disabled' : ''}`}
        onClick={(e) => handleNavigation('/products', e)}
      >
        <FaSearch className="nav-icon" />
        <span className="nav-label">Browse</span>
      </Link>
      <Link 
        to="/cart" 
        className={`nav-item ${isActive('/cart') ? 'active disabled' : ''}`}
        onClick={(e) => handleNavigation('/cart', e)}
      >
        <FaShoppingCart className="nav-icon" />
        <span className="nav-label">Cart</span>
      </Link>
      <Link 
        to="/alerts" 
        className={`nav-item ${isActive('/alerts') ? 'active disabled' : ''}`}
        onClick={(e) => handleNavigation('/alerts', e)}
      >
        <FaBell className="nav-icon" />
        <span className="nav-label">Alerts</span>
      </Link>
      <Link 
        to="/profile" 
        className={`nav-item ${isActive('/profile') ? 'active disabled' : ''}`}
        onClick={(e) => handleNavigation('/profile', e)}
      >
        <FaUser className="nav-icon" />
        <span className="nav-label">Profile</span>
      </Link>
    </nav>
  );
};

export default MobileNavigationBuyer;
